export const CRM_ACTIVITY_URL_POSTFIX = 'activities';
